function useGTM() {
    const sendEvent = (eventName, options = {}) => {
        if (!window.dataLayer) {
            console.log('No dataLayer. Aborting.');
            return;
        }

        if (!eventName) {
            console.log('No eventName given. Aborting.');
            return;
        }

        const data = {
            event: eventName,
            ...options
        };

        window.dataLayer.push(data);
    }

    return {
        sendEvent,
    };
}

export default useGTM;
